import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[bsClickableRow]',
  exportAs: 'bsClickableRow',
})
export class ClickableRowDirective<T> {
  @Input() bsClickableRowFn: ((element: T) => void) | undefined;
  @Input() bsClickableRowParam!: T;

  @HostBinding('class.clickable-row') get clickableRow(): boolean {
    return !!this.bsClickableRowFn;
  }

  @HostListener('click') onClick(): void {
    if (this.bsClickableRowFn) {
      this.bsClickableRowFn(this.bsClickableRowParam);
    }
  }
}
